import React from 'react';
import { cn } from '@/lib/utils';

export type DocumentRowInputVariant = 'text' | 'amount';

export interface DocumentRowInputProps {
  value: string;
  onChange: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  active?: boolean;
  placeholder?: string;
  variant?: DocumentRowInputVariant;
  dir?: 'ltr' | 'rtl';
  disabled?: boolean;
  className?: string;
}

const DocumentRowInput: React.FC<DocumentRowInputProps> = ({
  value,
  onChange,
  onFocus,
  onBlur,
  active = false,
  placeholder,
  variant = 'text',
  dir,
  disabled,
  className,
}) => {
  const isAmount = variant === 'amount';

  return (
    <input
      type="text"
      inputMode={isAmount ? 'numeric' : 'text'}
      dir={dir ?? (isAmount ? 'ltr' : undefined)}
      value={value}
      disabled={disabled}
      placeholder={placeholder}
      onFocus={onFocus}
      onBlur={onBlur}
      onChange={(e) => onChange(e.target.value)}
      className={cn(
        'w-full rounded-md border border-input bg-background outline-none transition-[height,font-size,padding,box-shadow] duration-150',
        isAmount && 'font-mono tabular-nums',
        active
          ? isAmount
            ? 'h-11 border-sky-300 px-3 text-lg font-semibold tracking-wide text-slate-900 shadow-sm ring-2 ring-sky-200'
            : 'h-11 border-sky-300 px-3 text-base font-medium text-slate-900 shadow-sm ring-2 ring-sky-200'
          : isAmount
            ? 'h-8 px-2 text-xs text-slate-600'
            : 'h-8 px-2 text-xs text-slate-600',
        disabled && 'cursor-not-allowed opacity-50',
        className,
      )}
    />
  );
};

export default DocumentRowInput;
